import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=c3ae6aac&scoped=true"
import script from "./OurServices.vue?vue&type=script&lang=js"
export * from "./OurServices.vue?vue&type=script&lang=js"
import style0 from "./OurServices.vue?vue&type=style&index=0&id=c3ae6aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ae6aac",
  null
  
)

export default component.exports